module.exports = __webpack_public_path__ + "static/media/license.b93d7de3.svg";